import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

export const ErrorIcon = (props: IconProps): JSX.Element => (
  <Icon w="226px" h="130px" viewBox="0 0 226 130" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M176 3.75C176.69 3.75 177.25 4.30964 177.25 5V11C177.25 11.6904 176.69 12.25 176 12.25C175.31 12.25 174.75 11.6904 174.75 11V5C174.75 4.30964 175.31 3.75 176 3.75Z"
      fill="#F28F8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M176 17.75C176.69 17.75 177.25 18.3096 177.25 19V25C177.25 25.6904 176.69 26.25 176 26.25C175.31 26.25 174.75 25.6904 174.75 25V19C174.75 18.3096 175.31 17.75 176 17.75Z"
      fill="#F28F8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M164.75 15C164.75 14.3096 165.31 13.75 166 13.75H172C172.69 13.75 173.25 14.3096 173.25 15C173.25 15.6904 172.69 16.25 172 16.25H166C165.31 16.25 164.75 15.6904 164.75 15Z"
      fill="#F28F8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M178.75 15C178.75 14.3096 179.31 13.75 180 13.75H186C186.69 13.75 187.25 14.3096 187.25 15C187.25 15.6904 186.69 16.25 186 16.25H180C179.31 16.25 178.75 15.6904 178.75 15Z"
      fill="#F28F8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.5 107.75C63.1904 107.75 63.75 108.31 63.75 109V113C63.75 113.69 63.1904 114.25 62.5 114.25C61.8096 114.25 61.25 113.69 61.25 113V109C61.25 108.31 61.8096 107.75 62.5 107.75Z"
      fill="#F28F8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.5 119.75C63.1904 119.75 63.75 120.31 63.75 121V125C63.75 125.69 63.1904 126.25 62.5 126.25C61.8096 126.25 61.25 125.69 61.25 125V121C61.25 120.31 61.8096 119.75 62.5 119.75Z"
      fill="#F28F8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.25 117C53.25 116.31 53.8096 115.75 54.5 115.75H58.5C59.1904 115.75 59.75 116.31 59.75 117C59.75 117.69 59.1904 118.25 58.5 118.25H54.5C53.8096 118.25 53.25 117.69 53.25 117Z"
      fill="#F28F8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.25 117C65.25 116.31 65.8096 115.75 66.5 115.75H70.5C71.1904 115.75 71.75 116.31 71.75 117C71.75 117.69 71.1904 118.25 70.5 118.25H66.5C65.8096 118.25 65.25 117.69 65.25 117Z"
      fill="#F28F8E"
    />
    <circle cx="113.5" cy="68" r="55" fill="#FFF5F5" />
    <path
      d="M100.833 20C100.836 20.0211 100.838 20.0422 100.84 20.0633C101.556 26.5282 103.542 32.8885 106.803 38.7446C108.889 42.4917 111.498 46.0325 114.631 49.2622C119.604 54.3895 125.41 58.2303 131.629 60.7768C139.191 63.8736 147.364 65.0561 155.39 64.3099C158.019 64.0654 160.633 63.614 163.204 62.9552C163.278 63.6356 163.339 64.3172 163.385 64.9995C163.727 70.0278 163.306 75.0929 162.124 80.0086C160.956 84.8691 159.045 89.5835 156.393 93.9716C155.187 95.9667 153.828 97.8944 152.317 99.7377L137.805 111.82C131.722 115.172 125.089 117.157 118.353 117.783C110.327 118.53 102.154 117.347 94.5918 114.25C88.3732 111.704 82.567 107.863 77.5938 102.736C74.461 99.506 71.8522 95.9652 69.7656 92.2181C66.5047 86.362 64.5193 80.0017 63.8032 73.5368C63.2507 68.5489 63.4537 63.4987 64.4093 58.5696C65.3369 53.7854 66.9735 49.1152 69.3166 44.7269C71.7098 40.2447 74.84 36.0566 78.7043 32.3412C81.7794 29.3848 85.1387 26.9013 88.6919 24.8892C92.5492 22.7048 96.6349 21.0758 100.833 20Z"
      fill="#E97C7C"
      fillOpacity="0.08"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.117 14.0835C104.466 13.0221 108.917 12.495 113.368 12.5C119.087 12.5065 124.807 13.3918 130.306 15.1521C134.697 16.5578 138.948 18.5213 142.945 21.0407C146.667 23.3855 150.167 26.211 153.358 29.5143C155.531 31.7642 157.477 34.1503 159.197 36.6443C162.084 40.8297 164.331 45.317 165.942 49.9709C167.565 54.6617 168.541 59.5213 168.872 64.4117C169.252 70.016 168.784 75.6618 167.473 81.1418C166.176 86.5605 164.054 91.8174 161.109 96.711C159.771 98.9359 158.262 101.085 156.584 103.14C156.06 103.782 155.115 103.878 154.473 103.354C153.832 102.83 153.736 101.885 154.26 101.243C155.847 99.2995 157.273 97.2673 158.539 95.1642C161.322 90.5388 163.329 85.5688 164.555 80.4436C165.796 75.2599 166.238 69.9179 165.879 64.6143C165.566 59.9865 164.643 55.3889 163.107 50.9521C161.584 46.5504 159.458 42.3066 156.727 38.3475C155.1 35.9883 153.258 33.7296 151.2 31.5984C148.178 28.4696 144.865 25.7963 141.346 23.5788C137.565 21.1961 133.545 19.3389 129.391 18.0093C124.189 16.344 118.777 15.5061 113.364 15.5C109.153 15.4953 104.941 15.9941 100.828 16.998C96.1976 18.1281 87.4489 22.3112 87.4489 22.3112C87.4489 22.3112 80.1926 27.0506 76.9626 30.1693C72.9038 34.0884 69.618 38.5042 67.1063 43.2285C64.6471 47.8543 62.9288 52.778 61.9549 57.8232C60.9514 63.0213 60.7381 68.3477 61.3184 73.6086C62.0705 80.4271 64.1553 87.1338 67.5788 93.3083C69.7692 97.259 72.5087 100.994 75.8002 104.402C81.0248 109.811 87.1215 113.861 93.6497 116.546C101.59 119.811 110.172 121.059 118.602 120.272C125.676 119.611 132.639 117.518 139.024 113.985C139.748 113.584 140.661 113.846 141.062 114.571C141.463 115.296 141.201 116.208 140.476 116.61C133.721 120.348 126.357 122.56 118.881 123.259C109.973 124.09 100.903 122.772 92.5087 119.32C85.6046 116.481 79.1599 112.199 73.6423 106.486C70.1671 102.887 67.2715 98.941 64.9551 94.763C61.3349 88.2338 59.1313 81.1433 58.3365 73.9375C57.7233 68.3781 57.9485 62.7491 59.0092 57.2546C60.0388 51.9212 61.8557 46.714 64.4574 41.8202C67.1151 36.8213 70.5906 32.1517 74.8788 28.0112C78.2909 24.7165 82.0201 21.9475 85.9657 19.7035C90.4541 17.1508 95.2205 15.2785 100.117 14.0835Z"
      fill="#FBBABB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M76.2349 36.6982C77.3113 35.419 78.4637 34.1834 79.6919 32.9974C82.6884 30.1037 85.9634 27.6716 89.4288 25.7005L90.1661 26.9968L89.4288 25.7005C91.6587 24.4321 93.9668 23.355 96.3295 22.4685C97.1052 22.1775 97.9698 22.5704 98.2608 23.3461C98.5518 24.1217 98.1589 24.9864 97.3833 25.2774C95.1674 26.1087 93.003 27.1188 90.912 28.3082C87.6631 30.1562 84.5902 32.4377 81.7759 35.1554C80.6222 36.2695 79.5403 37.4296 78.5302 38.6298C77.9968 39.2637 77.0506 39.3451 76.4167 38.8117C75.7829 38.2783 75.7014 37.332 76.2349 36.6982Z"
      fill="#FBBABB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.9854 40.7296C75.6762 41.1868 75.8657 42.1174 75.4085 42.8083C74.6056 44.0216 73.8667 45.2653 73.1919 46.5348C72.6935 47.4723 72.23 48.4239 71.8016 49.3876C71.465 50.1446 70.5785 50.4854 69.8215 50.1488C69.0646 49.8123 68.7237 48.9258 69.0603 48.1688C69.5172 47.1412 70.0114 46.1265 70.5429 45.1266C71.2625 43.7729 72.0505 42.4465 72.9067 41.1527C73.3639 40.4618 74.2945 40.2724 74.9854 40.7296Z"
      fill="#FBBABB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M142.467 113.801C142.093 113.221 142.261 112.447 142.841 112.073C146.385 109.793 149.542 106.942 151.581 104.656C152.041 104.141 152.831 104.096 153.346 104.556C153.861 105.015 153.906 105.806 153.446 106.321C151.268 108.761 147.942 111.764 144.194 114.176C143.614 114.549 142.84 114.382 142.467 113.801Z"
      fill="#FBBABB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.9196 26.8158C35.9196 28.0435 34.9249 29.0379 33.6981 29.0379C32.4707 29.0379 31.4766 28.0435 31.4766 26.8158C31.4766 25.5887 32.4707 24.5938 33.6981 24.5938C34.9249 24.5938 35.9196 25.5887 35.9196 26.8158Z"
      fill="#FFE5E6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M219.39 68.9461C219.39 70.5734 218.072 71.8922 216.445 71.8922C214.818 71.8922 213.5 70.5734 213.5 68.9461C213.5 67.3187 214.818 66 216.445 66C218.072 66 219.39 67.3187 219.39 68.9461Z"
      fill="#FBBABB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.713 76.8573C47.713 77.8831 46.8818 78.7145 45.8562 78.7145C44.8312 78.7145 44 77.8831 44 76.8573C44 75.8314 44.8312 75 45.8562 75C46.8818 75 47.713 75.8314 47.713 76.8573Z"
      stroke="#FFE5E6"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M76.3336 12.5424C76.3336 13.7701 75.3389 14.7645 74.1121 14.7645C72.8853 14.7645 71.8906 13.7701 71.8906 12.5424C71.8906 11.3153 72.8853 10.3203 74.1121 10.3203C75.3389 10.3203 76.3336 11.3153 76.3336 12.5424Z"
      stroke="#FFE5E6"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M191.482 114.313L191 116L190.518 114.313C190.265 113.427 189.573 112.735 188.687 112.482L187 112L188.687 111.518C189.573 111.265 190.265 110.573 190.518 109.687L191 108L191.482 109.687C191.735 110.573 192.427 111.265 193.313 111.518L195 112L193.313 112.482C192.427 112.735 191.735 113.427 191.482 114.313Z"
      fill="#FBBABB"
      stroke="#FBBABB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.7228 63.4701L20 66L19.2772 63.4701C18.8975 62.1412 17.8588 61.1025 16.5299 60.7228L14 60L16.5299 59.2772C17.8588 58.8975 18.8975 57.8588 19.2772 56.5299L20 54L20.7228 56.5299C21.1025 57.8588 22.1412 58.8975 23.4701 59.2772L26 60L23.4701 60.7228C22.1412 61.1025 21.1025 62.1412 20.7228 63.4701Z"
      fill="#FBBABB"
      stroke="#FBBABB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="126.938"
      y="47"
      width="10"
      height="48"
      rx="5"
      transform="rotate(45 126.938 47)"
      fill="#F28F8E"
    />
    <rect
      x="93"
      y="54.0703"
      width="10"
      height="48"
      rx="5"
      transform="rotate(-45 93 54.0703)"
      fill="#F28F8E"
    />
  </Icon>
);
